export const config = {
    GOOGLE_SHEET_KEY: process.env.REACT_APP_GOOGLE_SHEET_API_KEY,
}